define(function(require) {
	const tpl = require('civicsViews/InviteApplicant/templates/t_lov_invite_applicant.hbs');
	const AvailableFeatures = require('civicsUtils/available_features');
	const SelectFavoritesView = require('civicsViews/favoriteContacts/v_lov_favorite');
	const FavoriteController = require('civicsViews/favoriteContacts/controllers/main_controller');
	const FavoritesCollection = require('civicsCollections/portal/favorite_contact_collection');
    const InviteEditView = require('civicsViews/InviteApplicant/v_cpv_invite_applicant.js');
	const invitation_collection = require('civicsCollections/portal/invitation_collection');
	const ViewManager = require('civicsUtils/view_manager');

	return Marionette.LayoutView.extend({
		template: tpl,
        regions: {
			favoritesListRegion: '@ui.favoriteDiv',
			invitationRegion: '@ui.invitationDiv'
		},

		ui: {
            favoriteDiv: '.favorites-container-modal',
            invitationDiv: '.invitation-container',
            favoriteRadio: 'input[name="select-invite-applicant"][value="favoritesFlow"]',
			inviteRadio: 'input[name="select-invite-applicant"][value="inviteFlow"]',
			inviteFlowRadio: 'input[name="select-invite-applicant"][value="inviteFlow"]',
			inviteApplicantButtons: '.invite-applicant-buttons',
            selectFlowButton: '.selectFlow',
			closeModalButton: '.bbm-btn-close',
            cancelButton: '.cancel-select-favorites'

		},
		events: {
			'click @ui.selectFlowButton': 'selectFlowClicked',
			'click @ui.closeModalButton':'cancelClicked',
			'click @ui.cancelButton':'cancelClicked'
		},
		childEvents: {
			'invitation:added': 'callInvitationAdded',
			'cancel:clicked':'cancelClicked',
		},
		initialize: function(options) {
            this.config = options.config;
            this.controller = options.controller;
            this.favorites = options.favorites;
            this.instrumentType = options.instrumentType;
            this.additionalCapacityTypes = options.additionalCapacityTypes;
            this.applicantTypes = options.applicantTypes;
            this.isAddProcess = options.isAddProcess;
            this.primaryApplicant = options.primaryApplicant;
            this.modalRegion = options.modalRegion;
            this.favoriteContactEnabled = AvailableFeatures.FavoriteContacts() && this.config.globalConfig.favoriteContact == 'Show';
			this.setupFavorites();

		},
		onShow: function() {
			ViewManager.loading(true);
            this.showInviteEditView();
			$.when(
				this.favoritesReadyPromise
			).done(function() {
				ViewManager.loading(false);
			}.bind(this)).fail(function() {
				ViewManager.loading(false);
			});

		},
        setupFavorites: function () {
			if (this.favoriteContactEnabled) {
				this.favoritesController = new FavoriteController(this.config);
				this.favorites = new FavoritesCollection();
				let sortAvailable = true;
				this.favoritesReadyPromise = this.favoritesController.loadFavorites(sortAvailable, true);

				this.favoritesReadyPromise.done((data) => {
					this.favorites.add(data.favorites);
					this.showFavoritesView();
					this.setDefaultOption();
				});
			}
		},
		showFavoritesView: function () {
			let favoritesView = new SelectFavoritesView({
				config: this.config,
				collection: this.favorites,
				controller: this.favoritesController,
				additionalCapacityTypes: this.additionalCapacityTypes,
				applicantTypes: this.applicantTypes,
                isInviteProcess: true,
				controller: this.favoritesController
			});			
			this.favoritesListRegion.show(favoritesView);
		},
		callInvitationAdded: function (cv, newInvitations){
			this.triggerMethod('invitation:added', newInvitations);

		},
		setDefaultOption: function (){
			this.ui.inviteFlowRadio[0].checked = true;
			this.getRegion('favoritesListRegion').$el.hide();
		},
		selectFlowClicked: function (e) {
			var $input = $(e.currentTarget).find('input[type="radio"]');
			this.flowType = $input.val();

			// Set checked via native DOM property to trigger CSS :checked pseudo-class
			this.ui.favoriteRadio[0].checked = (this.flowType === 'favoritesFlow');
			this.ui.inviteRadio[0].checked = (this.flowType === 'inviteFlow');

			if (this.flowType === 'favoritesFlow') {

				this.getRegion('invitationRegion').$el.stop(true).fadeOut(500, () => {
					this.getRegion('favoritesListRegion').$el.stop(true).fadeIn();
					this.$el.find('.invite-applicant-modal-container').addClass('showFavorites');
				});

				this.ui.inviteApplicantButtons.hide(); 
			} else if (this.flowType === 'inviteFlow') {
				this.getRegion('favoritesListRegion').$el.stop(true).fadeOut(500, () => {
					this.getRegion('invitationRegion').$el.stop(true).fadeIn();
					this.$el.find('.invite-applicant-modal-container').removeClass('showFavorites');
				});

				this.ui.inviteApplicantButtons.show();
			}
		},
		cancelClicked:function(){
			if(this.modalRegion) {
				this.modalRegion.hideModal();
			} else {
				this.destroy();
			}
		},

        showInviteEditView: function (){
            this.inviteEditView = new InviteEditView({
                config:this.config,
                modalRegion: this.modalRegion,
                instrumentType:this.instrumentType,
                additionalCapacityTypes: this.additionalCapacityTypes,
                applicantTypes: this.applicantTypes,
                collection: new invitation_collection(),
                isAddProcess: this.isAddProcess,
                primaryApplicant: this.primaryApplicant
            });
            this.invitationRegion.show(this.inviteEditView);
        },
		templateHelpers: function(){
			return {
				showSelectOption: this.favoriteContactEnabled
            }
		}
	});
});
